import axios from '../../../utilities/axios';
import {LoginRequest} from '../../../models/requests/login.request';
import {TokenDto} from '../../../models/dtos/token.dto';

export const loginRequest = async (request: LoginRequest): Promise<TokenDto> => {
  try {
    const response = await axios.post<TokenDto>(
      `${process.env.REACT_APP_BASE_URL}/auth/login`,
      {...request},
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
